<template>
    <!-- 保单详情 -->
    <dialogWrap
      v-model="detailDailogVisible"
      title="保单详情"

      :width="'824px'"
      :hasFooter="false"
    >
      <el-form label-position="right" v-if="detailDailogVisible">
        <!-- 1: '交强险',2: '商业险',3: '承运人责任险', 4: '客伤险',5: '车船税',6: '盗抢险' -->
        <column-box :column="2" :list="source.type===2?policyList:list" :source="source">
        </column-box>
        <el-form-item label="保单附件:" class="alone" label-width="80px">
            <show-img-and-file :list="fileList" />
          </el-form-item>
      </el-form>
    </dialogWrap>
</template>
<script>
import selectOption from '@/store/dict/selectOptionDict'

export default {
  props: {
    source: {
      type: Object,
      default: () => ({}),
    },
    fileList: {
      type: Array,
      default: () => [],
    }, // 详情附件列表
  },
  data() {
    return {
      detailDailogVisible: false,
      // 非商业险保单详情数据
      list: [
        {
          key: 'plateNo',
          name: '车牌号',
        },
        {
          key: 'brandName',
          name: '品牌',
        },
        {
          key: 'seriesName',
          name: '车系',
        },
        {
          key: 'carModelName',
          name: '车型',
        },
        {
          key: 'carId',
          name: '车辆ID',
        },
        {
          key: 'typeName',
          name: '保险类型',
        },
        {
          key: 'policyNo',
          name: '保单号',
        },
        {
          key: 'premium',
          name: '保费',
          finance: true,
        },
        {
          key: 'providerName',
          name: '保险公司',
        },
        {
          key: 'state',
          name: '保单状态',
        },
        {
          key: 'startDate',
          name: '开始日期',
        },
        {
          key: 'endDate',
          name: '结束日期',
        },
        {
          key: 'remarks',
          name: '备注',
          alone: true,
        },
      ],
      // 商业险详情数据
      policyList: [
        {
          key: 'plateNo',
          name: '车牌号',
        },
        {
          key: 'brandName',
          name: '品牌',
        },
        {
          key: 'seriesName',
          name: '车系',
        },
        {
          key: 'carModelName',
          name: '车型',
        },
        {
          key: 'carId',
          name: '车辆ID',
        },
        {
          key: 'typeName',
          name: '保险类型',
        },
        {
          key: 'policyNo',
          name: '保单号',
        },
        {
          key: 'premium',
          name: '保费',
          finance: true,
        },
        {
          key: 'provider',
          name: '保险公司',
        },
        {
          key: 'state',
          name: '保单状态',
        },
        {
          key: 'startDate',
          name: '开始日期',
        },
        {
          key: 'endDate',
          name: '结束日期',
        },
        {
          key: 'stopDate',
          name: '停保时间',
        },
        {
          key: 'resumeDate',
          name: '复保时间',
        },
        {
          key: 'remarks',
          name: '备注',
          alone: true,
        },
      ],
    }
  },
  watch: {
    source() {
      this.dealKey()
    },
  },
  methods: {
    // 处理显示字段
    dealKey() {
      const { state, stopDate, resumeDate } = this.source
      // eslint-disable-next-line vue/no-mutating-props
      this.source.state = selectOption.insuranceState[state]
      // eslint-disable-next-line vue/no-mutating-props
      this.source.stopDate = stopDate && stopDate.split(' ')[0]
      // eslint-disable-next-line vue/no-mutating-props
      this.source.resumeDate = resumeDate && resumeDate.split(' ')[0]
    },
  },
}
</script>
<style lang="scss" scoped>
.alone ::v-deep .el-form-item__content {
  margin-left: 0 !important;
}
</style>
